import confetti from 'canvas-confetti'

const TG_PALETTE = ['#0080FF', '#FFD550', '#00A860', '#FF8C42', '#FF4000', '#9F60E8']

// Лёгкий салют — для промежуточных success-шагов (типа connect-done).
export function fireBurst(): void {
  const end = Date.now() + 600
  const interval = setInterval(() => {
    if (Date.now() > end) {
      clearInterval(interval)
      return
    }
    confetti({
      particleCount: 8,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.7 },
      colors: TG_PALETTE,
      scalar: 0.9,
    })
    confetti({
      particleCount: 8,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.7 },
      colors: TG_PALETTE,
      scalar: 0.9,
    })
  }, 150)
}

// Большой финальный салют — для финального welcome и первого захода в дашборд.
export function fireCelebration(): void {
  const count = 220
  const defaults: confetti.Options = {
    origin: { y: 0.7 },
    colors: TG_PALETTE,
  }
  const fire = (particleRatio: number, opts: confetti.Options) => {
    confetti({ ...defaults, ...opts, particleCount: Math.floor(count * particleRatio) })
  }
  fire(0.25, { spread: 26, startVelocity: 55 })
  fire(0.2, { spread: 60 })
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.85 })
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 })
  fire(0.1, { spread: 120, startVelocity: 45 })
}
